import { Model, AccessorsMutatorsDecorator } from "../../helpers";
import { Language, LANGUAGES } from "./language.model";

/**
 * @class Translation
 * @property {number} id
 * @property {Language} language
 * @property {string} property
 * @property {number} translatable_id
 * @property {string} translatable_type
 * @property {string} translation
 */
export class Translation extends Model {

    setLanguage(value) {

        if (value instanceof Language) {

            return value;
        }

        value = LANGUAGES.find((language) => language.is(value));
        if (!value) {

            throw new Error("Unknown translation language");
        }

        return value;
    }
}

AccessorsMutatorsDecorator('id', 'language', 'property', 'translatable_id', 'translatable_type', 'translation')(
    Translation);


// WEBPACK FOOTER //
// ./src/pms-api/models/translation.model.js